<script setup lang="ts">
import PhotoData from './wellbeing-sale--assistant.const'
import type { IProps } from './wellbeing-sale--assistant.types'
import UiPhotoWithDescription from '@/components/UiPhotoWithDescription/UiPhotoWithDescription.vue'
import UiBoxThreeOnRow from '@/components/UiBoxThreeOnRow/UiBoxThreeOnRow.vue'
import type { IPhotoWithDescriptionFields } from '@/types/contentful'

defineProps<IProps>()
const { uiPhotoData, uiBoxes } = PhotoData()
</script>

<template>
  <div class="assistant">
    <div class="assistant__container">
      <UiPhotoWithDescription
        v-bind="uiPhotoData() as unknown as IPhotoWithDescriptionFields"
      />
      
      <p
        class="assistant__paragraph"
        v-html="$t('wellbeingSale.assistant.paragraphHTML')"
      />
      
      <UiBoxThreeOnRow
        :boxes="uiBoxes()"
        title=""
      />
  
      <UiButton
        size="big"
        :to="hookTo"
      >
        {{ $t('wellbeingSale.assistant.button') }}
      </UiButton>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.assistant {
  padding: 5rem 1.6rem;
  background-color: $purple-400;

  &__container {
    max-width: 136rem;
    width: 90%;
    margin: auto;
  }

  &__paragraph {
    @include h10;
    color: $white;
  }

  :deep(.cf-photoWithDescription__header) {
    order: 0;
    color: $white;
  }

  :deep(.cf-photoWithDescription__content:first-child) {
    order: 1;
  }

  :deep(.cf-photoWithDescription__content:last-child) {
    order: 2;
  }

  :deep(.cf-photoWithDescription__photoMobile) {
    order: 3;
  }

  :deep(.cf-photoWithDescription__contentText ) {
    color: $white;
  }

  :deep(.ui-box-three-on-row) {
    padding-top: 3.2rem;
    padding-bottom: 3.2rem;
    background-color: transparent;
  }

  :deep(.ui-box-three-on-row__title) {
    display: none;
  }

  :deep(.ui-box__title) {
    @include body-2-medium;
    display: flex;
    align-items: center;
    gap: 1.6rem;
    padding-bottom: 0;

    &:before {
      display: block;
      width: 3.2rem;
      height: 3.2rem;
      background-image: url('/images/wellbeing-sale/assistant/bullet.svg');
      content: '';
    }
  }

  :deep(.ui-box__description) {
    @include body-2;
    padding-top: 0;
    padding-left: 4.8rem;
  }

  :deep(.ui-box__line) {
    display: none;
  }

  :deep(.button) {
    display: block;
    margin: auto;
  }

  @include atS {
    &__paragraph {
      @include h9;
    }

    :deep(.cf-photoWithDescription__header) {
      order: inherit;
    }

    :deep(.cf-photoWithDescription__content:first-child) {
      order: inherit;
    }

    :deep(.cf-photoWithDescription__content:last-child) {
      order: inherit;
    }

    :deep(.cf-photoWithDescription__photoMobile) {
      order: inherit;
    }
  }

  @include atM {
    padding: 10rem 0;
  }

  @include atL {
    &__container {
      width: 100%;
    }
  }
}
</style>
